import styled from 'styled-components';
import { Icon, loading } from '@web-chat-core/ui-kit';
import { WaitingControlsSection } from 'pages/WaitingApprovalPage/view';

const media = {
    tablet: '@media screen and (max-width: 800px)',
};

export const BrandWaitingApprovalRoot = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    width: 100%;
    min-height: 0;
    align-self: stretch;
`;

/** Центральный блок: логотип/видео + текст ожидания (brand-layout, Figma) */
export const BrandWaitingCenterStage = styled.div`
    display: flex;
    height: 591px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 46px;
    flex-shrink: 0;
    align-self: stretch;
    position: relative;
    width: 100%;

    ${media.tablet} {
        height: auto;
        min-height: 280px;
        flex: 1;
    }
`;

/** Тот же логотип, что в Header (`Logo` → logo-small.svg) */
export const BrandLogoWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const BrandWaitingStatusRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    flex-shrink: 0;
`;

export const BrandWaitingStatusText = styled.div`
    margin: 0;
    text-align: center;
    font-size: 14px;
    line-height: 20px;
    color: ${(props) => props.theme.root.colors.basicColors['60%']};
`;

export const BrandWaitingSpinnerIcon = styled(Icon)`
    flex-shrink: 0;
    ${loading};
`;

export const BrandWaitingControls = styled(WaitingControlsSection)`
    margin-top: 32px;
    flex-shrink: 0;
`;

export const BrandRejectedModalCard = styled.div`
    width: 455px;
    max-width: calc(100% - 48px);
    border-radius: 16px;
    background: ${(props) => props.theme.root.colors.basicColors['10%']};
    padding: 36px 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
    text-align: center;
`;

export const BrandRejectedModalTitle = styled.div`
    margin: 0;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 0.15px;
    color: ${(props) => props.theme.root.colors.basicColors['90%']};
`;

export const BrandRejectedModalActions = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;
    margin-top: 4px;
`;

export const BrandRetryButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
    letter-spacing: 0.25px;
    color: ${(props) => props.theme.root.colors.accent.textOrIcon};
`;

/** Плавное переключение логотип ↔ видео */
export const BrandMediaCrossfade = styled.div<{ $active: boolean }>`
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 46px;
    opacity: ${({ $active }) => ($active ? 1 : 0)};
    transition: opacity 400ms ease;
    pointer-events: ${({ $active }) => ($active ? 'auto' : 'none')};
`;
